import axios from 'axios';

import { headers, STOCK_JOURNAL } from '../../config';

export function getUsers(params) {
    return axios.get(`${STOCK_JOURNAL}/user`, { headers: headers(), params })
}